import React from "react";
import "./Chat.css";
import StopRoundedIcon from "@material-ui/icons/StopRounded";
import { Avatar } from "@material-ui/core";
import ReactTimeago from "react-timeago";
import { selectImage } from "../../features/appSlice";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { db, auth } from "../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";


function Chat({ id, username, timeStamp, read, imageUrl, profilePic }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [user] = useAuthState(auth);


  const open = () => {
    if (!read) {
      dispatch(selectImage(imageUrl));
      db.collection("posts").doc(id).set(
        {
          read: true,
        },
        { merge: true }
      );
      history.push("/chats/view");
    }
  };

  return (
    <div onClick={open} className="chat">
      <Avatar className="chat__avatar" src={user?.photoURL} />
      <div className="chat__info">
        <h4>{username}</h4>
        <p>
          {!read && "Tap to view -"}
          {""} <ReactTimeago date={new Date(timeStamp?.toDate()).toUTCString()} />
        </p>
      </div>
      {!read && <StopRoundedIcon className="chat__readIcon" />}
    </div>
  );
}

export default Chat;
